<!--
  Do not use the address tag:
  https://html.spec.whatwg.org/multipage/sections.html#:~:text=The%20address%20element%20must%20not%20be%20used%20to%20represent%20arbitrary%20addresses%20(e.g.%20postal%20addresses)%2C%20unless%20those%20addresses%20are%20in%20fact%20the%20relevant%20contact%20information.%20(The%20p%20element%20is%20the%20appropriate%20element%20for%20marking%20up%20postal%20addresses%20in%20general.)
-->
<kb-variable-heading kb-heading [attr.type]="type">
  {{name}}
  <span class="subline">
    {{subline}}
  </span>
</kb-variable-heading>
<div class="details" [class.floating]="type === 'floating'">
  <div class="text">
    <ng-content />
  </div>
  <ng-content select="[slot='picture']" />
</div>
